document.addEventListener('DOMContentLoaded', () => {
  const main = document.querySelector('#main');
  const menuButtons = document.querySelectorAll('[aria-controls=site-menu]');
  const mainMenuButton = document.querySelector('[aria-controls=site-menu]');
  const menu = document.querySelector('.site-menu');
  const menuBg = document.querySelector('.site-menu__bg');
  const pages = document.querySelectorAll('.site-menu__list > li');
  // const sectionBg = document.querySelector('.site-menu__section-bg');
  const searchButton = document.querySelector('[aria-controls=search]');
  // const searchForm = document.querySelector('#header-search-form');
  const menuDelayCap = 70;
  let menuInterval = null;
  let menuDelay = 0;
  let currentPage = '';
  /* eslint-disable no-undef */
  if (typeof setCurrentPage !== 'undefined') {
    currentPage = setCurrentPage;
  }
  let currentSection = '';
  /* eslint-disable no-undef */
  if (typeof setCurrentSection !== 'undefined') {
    currentSection = setCurrentSection;
  }

  function isTouchDevice() {
    return Boolean(
      'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
    );
  }

  function isMenuOpen() {
    return main.classList.contains('is-menu-open') === true;
  }

  function setMenu(menuButton) {
    if (isMenuOpen()) {
      if (menuButton.querySelector('.visually-hidden'))
        menuButton.querySelector('.visually-hidden').innerHTML = 'Close';
    } else {
      if (menuButton.querySelector('.visually-hidden'))
        menuButton.querySelector('.visually-hidden').innerHTML = 'Open';
    }
    menu.setAttribute('aria-hidden', String(!isMenuOpen()));
    menu.hidden = !isMenuOpen();
    menuButton.setAttribute('aria-expanded', String(isMenuOpen()));
  }

  function toggleMenu(menuButton) {
    main.classList.toggle('is-menu-open');
    setMenu(menuButton);
  }

  function openMenu() {
    clearInterval(menuInterval);
    menuDelay = 0;
    main.classList.add('is-menu-open');
    setMenu(mainMenuButton);
  }

  function closeMenu() {
    clearInterval(menuInterval);
    menuDelay = 0;
    main.classList.remove('is-menu-open');
    setMenu(mainMenuButton);
  }

  // When the escape key is pressed, close the menu.
  document.addEventListener('keydown', (e) => {
    if (isMenuOpen() && e.key === 'Escape') {
      closeMenu();
    }
  });

  // When the menu background is clicked, close the menu.
  if (menuBg) {
    menuBg.addEventListener('click', (e) => {
      closeMenu();
    });
  }

  // Toggle search section
  if (searchButton) {
    searchButton.addEventListener('click', (e) => {
      openMenu(mainMenuButton);
      document.querySelector('.site-menu__search-form input').focus();
    });
  }

  // Menu toggle buttons
  menuButtons.forEach((menuButton) => {
    menuButton.addEventListener('click', () => {
      toggleMenu(menuButton);
    });
  });

  pages.forEach((el) => {
    const toggle = (e) => {
      clearInterval(menuInterval);
      menuDelay = 0;
      if (
        e.target.parentNode.parentNode.getAttribute('aria-expanded') === 'true'
      ) {
        contract();
      } else {
        expand();
      }
      e.preventDefault();
      return false;
    };

    const contract = () => {
      main.classList.remove('is-menu-expanded');
      menu.classList.remove('is-expanded');

      pages.forEach((page) => {
        const active = false;
        if (page.hasAttribute('aria-expanded')) {
          page.setAttribute('aria-expanded', String(active));
          page
            .querySelector(':scope > .site-menu__section')
            .setAttribute('aria-hidden', String(!active));
          page.querySelector(':scope > .site-menu__section').hidden = !active;
        }
      });

      // sectionBg.hidden = true;
    };

    const expand = () => {
      menuDelay = menuDelayCap;

      main.classList.add('is-menu-open');
      main.classList.add('is-menu-expanded');
      menu.classList.add('is-expanded');

      pages.forEach((page) => {
        const active = page === el;
        if (page.hasAttribute('aria-expanded')) {
          page.setAttribute('aria-expanded', String(active));
          const section = page.querySelector(':scope > .site-menu__section');
          if (section) {
            section.setAttribute('aria-hidden', String(!active));
            section.hidden = !active;
          }
        }
      });
    };

    const hover = () => {
      // sectionBg.hidden = false;
    };

    const hoverIf = (condition, e) => {
      if (condition(e)) {
        clearInterval(menuInterval);
        menuDelay = menuDelayCap;
        menuInterval = setInterval(() => {
          menuDelay -= 1;
          if (menuDelay <= 0) {
            if (e.target.parentNode.hasAttribute('aria-expanded')) {
              expand();
            } else {
              contract();
            }
          }
        }, 1);
      }
    };

    const leaveA = () => {
      clearInterval(menuInterval);
      menuDelay = 0;
    };

    const leave = () => {
      clearInterval(menuInterval);
      menuDelay = 0;
    };

    const expandIf = (condition, e) => {
      if (condition(e)) {
        if (
          isTouchDevice &&
          e.target
            .closest('.site-menu__list-item')
            .getAttribute('aria-expanded') === 'true'
        ) {
          return true;
        }
        expand();
        e.preventDefault();
      }
    };

    const expandHoverIf = (condition, e) => {
      if (condition(e) && (menuDelay <= 0 || !isMenuOpen())) {
        if (e.target.parentNode.hasAttribute('aria-expanded')) {
          expand();
        } else {
          contract();
        }
        e.preventDefault();
      }
    };

    // const contractIf = (condition, e) => {
    //   clearInterval(menuInterval);
    //   menuDelay = 0;
    //   if (condition(e)) {
    //     contract();
    //     e.preventDefault();
    //   }
    // };

    const expandIfMobile = expandIf.bind(undefined, (e) => {
      return (
        isTouchDevice() &&
        e.target.closest('.site-menu__list-item').hasAttribute('aria-expanded')
      );
    });

    const hoverIfDesktop = hoverIf.bind(undefined, (e) => {
      return isTouchDevice() === false;
    });

    const expandHoverIfDesktop = expandHoverIf.bind(undefined, (e) => {
      return isTouchDevice() === false;
    });

    // const contractIfDesktop = contractIf.bind(undefined, (e) => {
    //   return isTouchDevice() === false;
    // });

    const back = el.querySelector('.site-menu__back');
    if (back) {
      back.addEventListener('click', (e) => {
        contract();
        e.preventDefault();
        return false;
      });
    }

    const closeButton = el.querySelector('.site-menu__close');
    if (closeButton) {
      closeButton.addEventListener('click', contract);
    }

    const toggleButton = el.querySelector('.site-menu__toggle');
    if (toggleButton) {
      toggleButton.addEventListener('click', toggle);
    }

    const a = el.querySelector(':scope > a');
    a.addEventListener('click', expandIfMobile);
    a.addEventListener('mouseenter', hover);
    a.addEventListener('mouseleave', leaveA);
    // a.addEventListener('focus', hover);
    menu.addEventListener('mouseleave', leave);

    a.addEventListener('mouseenter', hoverIfDesktop);
    a.addEventListener('mouseenter', expandHoverIfDesktop);

    contract();
  });

  // sub menu controls
  document
    .querySelectorAll('.site-menu__children-section--parent > .site-menu__link')
    .forEach((el) => {
      el.addEventListener('click', (e) => {
        const parent = el.parentNode;
        const active = !(el.getAttribute('aria-expanded') === 'true');

        // close others
        document
          .querySelectorAll('.site-menu__children-section--parent')
          .forEach((parentEl) => {
            const active = false;
            parentEl
              .querySelector('.site-menu__link')
              .setAttribute('aria-expanded', String(active));
            parentEl
              .querySelector('.site-menu__children-section-sub-list')
              .setAttribute('aria-hidden', String(!active));
            parentEl.querySelector(
              '.site-menu__children-section-sub-list'
            ).hidden = !active;
          });

        // open active
        el.setAttribute('aria-expanded', String(active));
        parent
          .querySelector('.site-menu__children-section-sub-list')
          .setAttribute('aria-hidden', String(!active));
        parent.querySelector('.site-menu__children-section-sub-list').hidden =
          !active;
        e.preventDefault();
      });
    });

  // detect current sections and pages
  if (typeof currentPage !== 'undefined' && currentPage) {
    const page = document.querySelector(
      '.page-nav a[data-id="' + currentPage + '"]'
    );
    if (page) {
      page.classList.add('page-nav__link--active');
    }
    const link = document.querySelector(
      '.site-menu__link--child[data-id="' + currentPage + '"]'
    );
    if (link) {
      link.classList.add('site-menu__link--active');
      if (link.classList.contains('site-menu__link--grandchild')) {
        link
          .closest('.site-menu__children-section-sub-list')
          .setAttribute('aria-hidden', 'false');
        link.closest('.site-menu__children-section-sub-list').hidden = false;
        link
          .closest('.site-menu__children-section-sub-list')
          .parentNode.querySelector('> a')
          .setAttribute('aria-expanded', 'true');
      }
    }
  }

  if (typeof currentSection !== 'undefined' && currentSection) {
    const section = document.querySelector(
      '.site-menu__list-item[data-id="' + currentSection + '"]'
    );
    const active = true;
    if (section && !isTouchDevice()) {
      section.setAttribute('aria-expanded', String(active));
      if (section.querySelector(':scope > .site-menu__section')) {
        section
          .querySelector(':scope > .site-menu__section')
          .setAttribute('aria-hidden', String(!active));
        section.querySelector(':scope > .site-menu__section').hidden = !active;
      }
    }
    const link = document.querySelector(
      '.site-menu__link--parent[data-id="' + currentSection + '"]'
    );
    if (link) {
      link.classList.add('site-menu__link--active');
    }
  }
});
